"use client";

import { type ReactNode } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { TooltipProvider } from "@/components/ui/tooltip";
import { AuthProvider } from "@/contexts/AuthContext";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import TranslationProvider from "@/contexts/TranslationsProvider";
import LeafletIconsPatch from "@/lib/LeafletIconsPatch";
import { AUEProvider } from "@/contexts/AUEContext";
import { ProyectosPropiosProvider } from "@/contexts/ProyectosPropiosContext";
import { FondoFederProvider } from "@/contexts/FondoFederContext";
import { FoldersProvider } from "@/contexts/FileSystemContext";
import { OtrosProyectosProvider } from "@/contexts/OtrosProyectosContext";
import UserThemeSync from "@/contexts/UserThemeSync";
import { ThemeProvider } from "next-themes";
import { NotificacionesProvider } from "@/contexts/NotificationContext";

import { IndicadoresProvider } from "@/contexts/IndicadoresContext";

const queryClient = new QueryClient();

export default function Providers({ children }: { children: ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <ThemeProvider
          attribute="class"
          defaultTheme="light"
          enableSystem={false}
          storageKey="theme"
          disableTransitionOnChange
        >
          <AuthProvider>
            <UserThemeSync />
            <TranslationProvider>
              <AUEProvider>
                <ProyectosPropiosProvider>
                  <OtrosProyectosProvider>
                    <FondoFederProvider>
                      <FoldersProvider>
                        <IndicadoresProvider>
                        
                        <NotificacionesProvider>
                          <Toaster />
                          <Sonner />
                          <LeafletIconsPatch />

                            {children}
                          
                        </NotificacionesProvider>
                        </IndicadoresProvider>
                      </FoldersProvider>
                    </FondoFederProvider>
                  </OtrosProyectosProvider>
                </ProyectosPropiosProvider>
              </AUEProvider>
            </TranslationProvider>
          </AuthProvider>
        </ThemeProvider>
      </TooltipProvider>
    </QueryClientProvider>
  );
}
